import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import FilterTags from 'components/commons/filters/filterTags';

import { AGGREGATOR_MOVEMENTS_FILTER } from 'constants/index';

import { getProductDetails, getTransactionsTink } from 'actions/aggregator/aggregatorData';
import { parseFilters } from 'utilities/filters/filtersParser';

class AggregatorMovementsFilterTagsClass extends React.PureComponent {
  handleOnFilter = () => {
    const {
      productType,
      productId,
      immFilters,
      getProductDetails,
      getTransactionsTink,
      bankId,
      isTinkAggregator,
    } = this.props;

    if (!isTinkAggregator) {
      productType &&
        productId &&
        getProductDetails(bankId, productType, productId, null, parseFilters(immFilters));
    } else {
      productType &&
        productId &&
        getTransactionsTink(productType, productId, null, null, parseFilters(immFilters));
    }
  };

  render() {
    return <FilterTags filtersId={AGGREGATOR_MOVEMENTS_FILTER} onFilter={this.handleOnFilter} />;
  }
}

AggregatorMovementsFilterTagsClass.defaultProps = {
  immFilters: {},
  getProductDetails: () => null,
  productType: '',
  productId: '',
  getTransactionsTink: () => null,
  isTinkAggregator: false,
};

AggregatorMovementsFilterTagsClass.propTypes = {
  immFilters: PropTypes.object,
  getProductDetails: PropTypes.func,
  productType: PropTypes.string,
  productId: PropTypes.string,
  bankId: PropTypes.string,
  getTransactionsTink: PropTypes.func,
  isTinkAggregator: PropTypes.bool,
};

const AggregatorMovementsFilterTags = connect(
  state => ({
    immFilters: state.filters.get(AGGREGATOR_MOVEMENTS_FILTER),
  }),
  {
    getProductDetails,
    getTransactionsTink,
  }
)(AggregatorMovementsFilterTagsClass);

export { AggregatorMovementsFilterTags };
